/**
 * Created by andrey on 20.05.2025
 */

import CleverAppsNative from "./cleverappsnative";
import Utils from "./utils";

const metrikaID = "102007880";

const YandexMetrika = {
    logEvent: function (options) {
        ym(metrikaID, "reachGoal", options.name, {
            order_price: options.order_price || 1
        });
    },

    logPurchase: function (options) {
        ym(metrikaID, "reachGoal", "purchase", {
            order_price: options.order_price,
            currency: options.currency
        });
    },

    logAdRevenue: function (options) {
        ym(metrikaID, "reachGoal", "ad_revenue", {
            order_price: options.order_price,
            currency: options.currency
        });
    }
};

export default {
    install: function () {
        CleverAppsNative.addPlugin("YandexMetrika", YandexMetrika);

        Utils.loadSdk("//mc.yandex.ru/metrika/tag.js", {
            onSuccess: function () {
                console.log("YandexMetrika loaded");
            }
        });

        window.ym = function () {
            // eslint-disable-next-line prefer-rest-params
            ym.a.push(arguments);
        };

        ym.a = [];
        ym.l = 1 * new Date();

        ym(metrikaID, "init", {
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true
        });
    }
};